import React from 'react'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as RouteLink} from 'react-router-dom'
import {getGlobalLink} from '../../utils/contentstack-utils'
import {useMultiStyleConfig} from '@chakra-ui/react'

const TertiaryLink = ({link, categoriesData}) => {
    const styles = useMultiStyleConfig('KenwoodMenu')

    const {url, label} = getGlobalLink({link: link.redirects, categoriesData})

    return (
        <Link
            as={RouteLink}
            to={url}
            {...styles.tertiaryLink}
            color={link?.label_hex_color || styles.tertiaryLink.color}
        >
            {label}
        </Link>
    )
}

TertiaryLink.propTypes = {
    link: PropTypes.object,
    categoriesData: PropTypes.object,
    asSecondaryCard: PropTypes.bool,
}

export default TertiaryLink
